
import { CreateOrUpdateBaseService } from '../../../../../common/services/createOrUpdateBase.service';
import { services } from '../../../../../constants/services';
export class CreateOrUpdateRoleService extends CreateOrUpdateBaseService<any,any> {
    url = `${services.users}/access/roles`;
}